import "./title.scss"
import { HelloWorld } from "@reactive/components/hello-world";

//Read Props from DOM
export default function Title () {
    HelloWorld({ title: "Title prop!", subtitle: "Subtitle prop!", targets: "[data-reactive][data-bundle='title']"});
}